/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.0
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/no-unused-state */

import React from 'react';
import T from 'prop-types';
import { focusManager } from '@accedo/vdkweb-navigation';
import FocusDiv from '../FocusDiv/FocusDiv';
import { updatePrefix } from '../utils/utils';
import ReactList from './ReactList';
import focusGridTheme from './focusGrid.scss';
var GRID_ALIGNMENT = {
  VERTICAL: 'grid-align-vertical',
  HORIZONTAL: 'grid-align-horizontal'
};

// eslint-disable-next-line valid-jsdoc
/**
 *
 * FocusGrid is a spatial focus aware grid. The core of the grid currently handled
 * by the package, [react-list](https://www.npmjs.com/package/react-list).
 *
 * The grid takes a datasource, which is responsible for returning data that needs
 * to be presented in the grid. The implementation can be opaque from the grid,
 * but it must implement two functions, which the grid uses to fetch data and
 * information for populating the grid.
 *
 * @returns {React.ReactElement} The FocusDivButton Element
 */
var FocusGrid = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FocusGrid, _React$PureComponent);
  var _super = _createSuper(FocusGrid);
  function FocusGrid(_props) {
    var _this;
    _classCallCheck(this, FocusGrid);
    _this = _super.call(this, _props);
    _defineProperty(_assertThisInitialized(_this), "setRef", function (c) {
      _this._grid = c;
    });
    // We render row x col by using two react-list. This is the wrapping list
    _defineProperty(_assertThisInitialized(_this), "renderItemContainer", function (c, k) {
      var _this$props = _this.props,
        col = _this$props.col,
        itemReactListProps = _this$props.itemReactListProps,
        itemHeight = _this$props.itemHeight,
        itemWidth = _this$props.itemWidth,
        row = _this$props.row;
      var isHzl = _this.getIsHorizontal();
      _this.idxToRenderFnMap[c] = _this.idxToRenderFnMap[c] || function (r) {
        return _this.renderSquareItem(c * _this.getLengthFactor() + r);
      };
      var length = _this.getLengthFactor();
      var reactListProps = _objectSpread({
        axis: isHzl ? 'y' : 'x',
        itemRenderer: _this.idxToRenderFnMap[c],
        length: length
      }, _this.getCommonReactListProps());
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(c).concat(k),
        style: {
          width: itemWidth * (isHzl ? 1 : col),
          height: itemHeight * (isHzl ? row : 1),
          verticalAlign: 'top',
          display: 'inline-block'
        }
      }, /*#__PURE__*/React.createElement(ReactList, _extends({}, reactListProps, itemReactListProps)));
    });
    _defineProperty(_assertThisInitialized(_this), "renderSquareItem", function (index) {
      var _this$state = _this.state,
        stateData = _this$state.data,
        totalDataNumber = _this$state.totalDataNumber;
      if (index > totalDataNumber - 1) {
        return null;
      }
      var _this$props2 = _this.props,
        col = _this$props2.col,
        displayObject = _this$props2.displayObject,
        ds = _this$props2.ds,
        itemHeight = _this$props2.itemHeight,
        itemWidth = _this$props2.itemWidth,
        row = _this$props2.row,
        stayOnFirst = _this$props2.stayOnFirst;
      var isHzl = _this.getIsHorizontal();
      var _displayObject$props$ = displayObject.props.onClick,
        _onClick = _displayObject$props$ === void 0 ? function () {} : _displayObject$props$;
      var stateDataLen = stateData.length;
      var diff = isHzl ? col : row;
      if (stateDataLen <= index + diff) {
        if (!_this.isFetching && (!_this.fetchingIndex || _this.fetchingIndex <= index)) {
          var newFetchingIndex = stateDataLen + _this.targetRange;
          if (newFetchingIndex > totalDataNumber) {
            newFetchingIndex = totalDataNumber;
          }
          _this.fetchingIndex = newFetchingIndex;
          _this.isFetching = true;
          ds.getData(stateDataLen, newFetchingIndex).then(function (data) {
            _this.isFetching = false;
            if (_this.hasUnmounted) {
              return;
            }
            _this.setState(function (state) {
              return {
                data: state.data.concat(data)
              };
            });
          })["catch"](function () {
            _this.isFetching = false;
          });
        }
        if (stateDataLen <= index) {
          return null;
        }
      }
      var data = stateData[index];
      var itemColIndex = isHzl ? Math.floor(index / row) : index % col;
      var itemRowIndex = isHzl ? index % row : Math.floor(index / col);
      var itemNav = _this.createNavForItem({
        index: index,
        itemColIndex: itemColIndex,
        itemRowIndex: itemRowIndex
      });
      var props = {
        key: data.id ? "item-".concat(data.id) : "item-idx-".concat(index),
        data: data,
        width: itemWidth,
        height: itemHeight,
        nav: itemNav,
        onFocus: function onFocus() {
          clearTimeout(_this.focusTimeoutId);

          // need to use a timeout here in case component is focused on first render,
          // as ReactList is not ready to scroll yet
          _this.focusTimeoutId = setTimeout(function () {
            if (!_this._grid || _this.hasUnmounted) {
              return;
            }
            var targetIdx = isHzl ? itemColIndex : itemRowIndex;
            var visibleRange = _this._grid.getVisibleRange();
            _this.setState({
              forwardFocusIndex: index
            });
            if (typeof _this._grid.scrollingTo === 'number') {
              return;
            }
            var scrollIdx = visibleRange[0];
            if (stayOnFirst) {
              scrollIdx = targetIdx;
            } else if (typeof _this._grid.scrollingTo === 'number') {
              scrollIdx = _this._grid.scrollingTo;
            } else if (targetIdx < visibleRange[0]) {
              scrollIdx = targetIdx;
            } else if (targetIdx > visibleRange[1]) {
              var axisDimension = isHzl ? col : row;
              scrollIdx = targetIdx - axisDimension + 1;
              scrollIdx = scrollIdx >= 0 ? scrollIdx : 0;
            }
            _this._grid.scrollTo(scrollIdx);
            _this.lastFocusedItemIndex = targetIdx;
          }, 0);
        },
        onClick: function onClick() {
          return _onClick(data, index);
        }
      };
      return /*#__PURE__*/React.cloneElement(displayObject, props);
    });
    _this.state = {
      data: [],
      fetchingIndex: 0,
      forwardFocusIndex: null,
      totalDataNumber: 0
    };
    _this.idxToRenderFnMap = {};
    _this.getInitialData(_props);
    return _this;
  }
  _createClass(FocusGrid, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hasUnmounted = true;
      clearTimeout(this.focusTimeoutId);
      clearTimeout(this.scrollAroundTimeoutId);
    }
  }, {
    key: "getInitialData",
    value: function getInitialData(props) {
      var _this2 = this;
      var alignment = props.alignment,
        col = props.col,
        row = props.row,
        preFetch = props.preFetch,
        ds = props.ds,
        _props$initialIndex = props.initialIndex,
        initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex;
      var targetRange = alignment === GRID_ALIGNMENT.HORIZONTAL ? row * (col + preFetch) - 1 : col * (row + preFetch) - 1;
      this.targetRange = targetRange;
      Promise.all([ds.getData(0, initialIndex + targetRange), ds.getTotalNumber()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          data = _ref2[0],
          totalDataNumber = _ref2[1];
        if (_this2.hasUnmounted) {
          return;
        }
        _this2.setState({
          data: data,
          totalDataNumber: totalDataNumber
        });
      });
    }
  }, {
    key: "getVisibleRange",
    value: function getVisibleRange() {
      var _this$props3 = this.props,
        row = _this$props3.row,
        col = _this$props3.col,
        alignment = _this$props3.alignment;
      var multiplier = alignment === GRID_ALIGNMENT.HORIZONTAL ? row : col;
      var range = this._grid && this._grid.getVisibleRange();
      return range && [range[0] * multiplier, (range[1] + 1) * multiplier - 1];
    }
  }, {
    key: "getLengthFactor",
    value: function getLengthFactor() {
      return this.getIsHorizontal() ? this.props.row : this.props.col;
    }
  }, {
    key: "getIsHorizontal",
    value: function getIsHorizontal() {
      return this.props.alignment === GRID_ALIGNMENT.HORIZONTAL;
    }
  }, {
    key: "getCommonReactListProps",
    value: function getCommonReactListProps() {
      var _this$props4 = this.props,
        displayObject = _this$props4.displayObject,
        animation = _this$props4.animation,
        col = _this$props4.col,
        itemWidth = _this$props4.itemWidth;
      return {
        animation: animation,
        // Because ReactList is a PureComponent, `displayObject` needs to be
        // passed in case it has changed.
        displayObject: displayObject,
        type: 'uniform',
        listWidth: col * itemWidth
      };
    }
  }, {
    key: "getTopListIndexByItemIndex",
    value: function getTopListIndexByItemIndex(index) {
      if (index === 0) {
        return 0;
      }
      if (!index) {
        return null;
      }
      var _this$props5 = this.props,
        row = _this$props5.row,
        col = _this$props5.col;
      var isHzl = this.getIsHorizontal();
      var itemColIndex = isHzl ? Math.floor(index / row) : index % col;
      var itemRowIndex = isHzl ? index % row : Math.floor(index / col);
      return isHzl ? itemColIndex : itemRowIndex;
    }
  }, {
    key: "getTopListRenderer",
    value: function getTopListRenderer() {
      var _this$props6 = this.props,
        row = _this$props6.row,
        col = _this$props6.col,
        alignment = _this$props6.alignment;
      return row === 1 && alignment === GRID_ALIGNMENT.HORIZONTAL || col === 1 && alignment === GRID_ALIGNMENT.VERTICAL ? this.renderSquareItem : this.renderItemContainer;
    }
  }, {
    key: "scrollAround",
    value: function scrollAround(index) {
      var _this3 = this;
      if (this._grid) {
        this._grid.scrollAround(this.getTopListIndexByItemIndex(index));
      }
      clearTimeout(this.scrollAroundTimeoutId);
      this.scrollAroundTimeoutId = setTimeout(function () {
        focusManager.changeFocus("".concat(_this3.prefix).concat(index));
      }, 0);
    }
  }, {
    key: "createNavForItem",
    value: function createNavForItem(_ref3) {
      var _this4 = this;
      var index = _ref3.index,
        itemColIndex = _ref3.itemColIndex,
        itemRowIndex = _ref3.itemRowIndex;
      var prefix = this.prefix;
      var totalDataNumber = this.state.totalDataNumber;
      var _this$props7 = this.props,
        row = _this$props7.row,
        col = _this$props7.col,
        nav = _this$props7.nav,
        rtl = _this$props7.rtl;
      var isHzl = this.getIsHorizontal();
      var createId = function createId(shift) {
        var newIndex = index + shift;
        if (newIndex < 0) {
          return '';
        }

        // Allowing to scroll to the latest item when out of bound
        if (newIndex > totalDataNumber - 1) {
          newIndex = totalDataNumber - 1;
        }
        return "".concat(prefix).concat(newIndex);
      };
      var navInternal = ['up', 'down', 'left', 'right'].reduce(function (accumulator, direction) {
        accumulator["next".concat(direction)] = function () {
          var _this4$_grid;
          if (typeof ((_this4$_grid = _this4._grid) === null || _this4$_grid === void 0 ? void 0 : _this4$_grid.scrollingTo) === 'number' || _this4.isFetching) {
            return true;
          }
          var range = _this4.getVisibleRange();
          if (!range) {
            return undefined;
          }
          return index < range[0] || index > range[1];
        };
        return accumulator;
      }, {});
      var nextLeftHorizontal = itemColIndex > 0 ? createId(-row) : '';
      var nextRightHorizontal = itemColIndex < Math.ceil(this.state.totalDataNumber / row) - 1 ? createId(row) : '';
      var nextLeftVertical = itemColIndex > 0 ? createId(-1) : '';
      var nextRightVertical = itemColIndex < col - 1 ? createId(1) : '';
      if (rtl) {
        nextLeftHorizontal = nextRightHorizontal;
        nextRightHorizontal = itemColIndex > 0 ? createId(-row) : '';
        nextLeftVertical = nextRightVertical;
        nextRightVertical = itemColIndex > 0 ? createId(-1) : '';
      }
      var directionMap = isHzl ? {
        nextleft: nextLeftHorizontal,
        nextright: nextRightHorizontal,
        nextup: itemRowIndex > 0 ? createId(-1) : '',
        nextdown: itemRowIndex < row - 1 ? createId(1) : ''
      } : {
        nextleft: nextLeftVertical,
        nextright: nextRightVertical,
        nextup: itemRowIndex > 0 ? createId(-col) : '',
        nextdown: itemRowIndex < Math.ceil(this.state.totalDataNumber / col) - 1 ? createId(col) : ''
      };
      return _objectSpread({
        id: createId(0),
        parent: nav.id,
        internal: navInternal
      }, directionMap);
    }
  }, {
    key: "focusItemById",
    value: function focusItemById(index) {
      var range = this.getVisibleRange();
      if (range === undefined || range[0] === undefined || range[1] === undefined) {
        console.warn('Range is not defined');
        return;
      }
      if (index === undefined || index < range[0] || index > range[1]) {
        console.warn("index: ".concat(index, " exceed Grid range: ").concat(range, "], use lower range: ").concat(range[0]));
        index = range[0];
      }
      focusManager.changeFocus("".concat(this.prefix).concat(index));
    }
  }, {
    key: "render",
    value: function render() {
      var _ref4, _this$state$forwardFo;
      var _this$state2 = this.state,
        data = _this$state2.data,
        totalDataNumber = _this$state2.totalDataNumber;
      var _this$props8 = this.props,
        col = _this$props8.col,
        extraReactListProps = _this$props8.extraReactListProps,
        itemHeight = _this$props8.itemHeight,
        itemWidth = _this$props8.itemWidth,
        loadingEl = _this$props8.loadingEl,
        maskStyle = _this$props8.maskStyle,
        nav = _this$props8.nav,
        row = _this$props8.row,
        rtl = _this$props8.rtl,
        stayOnFirst = _this$props8.stayOnFirst,
        theme = _this$props8.theme,
        initialIndex = _this$props8.initialIndex;
      if (!data.length || !totalDataNumber) {
        return loadingEl;
      }

      // Setup unique prefix for Grid
      updatePrefix(this);
      var isHzl = this.getIsHorizontal();
      var lengthFactor = this.getLengthFactor();
      var dimensionStyle = {
        width: col * itemWidth
      };
      if (!isHzl) {
        dimensionStyle.height = row * itemHeight;
      }
      var focusDivProps = {
        nav: _objectSpread({
          forwardFocus: "".concat(this.prefix).concat((_ref4 = (_this$state$forwardFo = this.state.forwardFocusIndex) !== null && _this$state$forwardFo !== void 0 ? _this$state$forwardFo : initialIndex) !== null && _ref4 !== void 0 ? _ref4 : 0)
        }, nav),
        style: _objectSpread({
          overflow: 'scroll'
        }, dimensionStyle)
      };
      var maskCompStyle = _objectSpread({
        height: itemHeight * row,
        overflow: 'hidden',
        width: itemWidth * col
      }, maskStyle);
      var offset = stayOnFirst ? isHzl * col + !isHzl * row : 0;
      var reactListProps = _objectSpread({
        axis: isHzl ? 'x' : 'y',
        itemRenderer: this.getTopListRenderer(),
        length: Math.ceil(totalDataNumber / lengthFactor) + offset,
        useStaticSize: true,
        initialIndex: this.getTopListIndexByItemIndex(initialIndex)
      }, this.getCommonReactListProps());
      var _focusGridTheme$theme = _objectSpread(_objectSpread({}, focusGridTheme), theme),
        focusGridContainer = _focusGridTheme$theme.focusGridContainer;
      return /*#__PURE__*/React.createElement("div", {
        style: maskCompStyle
      }, /*#__PURE__*/React.createElement(FocusDiv, _extends({
        className: "".concat(focusGridContainer || '', " ").concat(focusGridTheme.scroll),
        dir: rtl ? 'rtl' : null
      }, focusDivProps), /*#__PURE__*/React.createElement(ReactList, _extends({
        ref: this.setRef
      }, reactListProps, extraReactListProps))));
    }
  }]);
  return FocusGrid;
}(React.PureComponent);
_defineProperty(FocusGrid, "displayName", 'UnconnectedFocusGrid');
FocusGrid.propTypes = {
  /** The alignment of Focus Grid to be vertical or horizontal. Support enum value of FocusGrid.ALIGNMENT.VERTICAL or FocusGrid.ALIGNMENT.HORIZONTAL. */
  alignment: T.oneOf([GRID_ALIGNMENT.VERTICAL, GRID_ALIGNMENT.HORIZONTAL]),
  /** Adds an animation when transitioning to elements. The duration is in milliseconds */
  animation: T.shape({
    duration: T.number
  }),
  /** Number of column in the grid. */
  col: T.number.isRequired,
  /** A React Component that will be used by the Focus Carousel, by using the React.cloneElement function, to clone items for the carousel. */
  displayObject: T.node.isRequired,
  /** Datasource of the grid. */
  ds: T.shape({
    getData: T.func.isRequired,
    getTotalNumber: T.func.isRequired
  }).isRequired,
  /**  */
  extraReactListProps: T.object,
  /**  */
  initialIndex: T.number,
  /** Height of each item in the grid. */
  itemHeight: T.number.isRequired,
  /** Extra props to pass to the items ReactList component. */
  itemReactListProps: T.object,
  /** Width of each item in the grid. */
  itemWidth: T.number.isRequired,
  /**  */
  loadingEl: T.node,
  /** Style to override the existing one of the grid mask. */
  maskStyle: T.object,
  /** Navigation property, see `@accedo/vdkweb-navigation`. */
  nav: T.object,
  /** The number of prefetch row / col when focus meet the boundary. There's a limitation on this value to be at least 2 if the size of the items is bigger than the ReactList threshold (100px by default) or 3 if not. */
  preFetch: T.number,
  /**  */
  row: T.number.isRequired,
  /** Number of row in the grid. */
  rtl: T.bool,
  /** True whether the grid must show elements from right to left. */
  stayOnFirst: T.bool,
  /** Styles to override the default theme  */
  theme: T.object
};
FocusGrid.defaultProps = {
  alignment: GRID_ALIGNMENT.HORIZONTAL,
  extraReactListProps: {},
  itemReactListProps: {},
  loadingEl: /*#__PURE__*/React.createElement("div", null, "Loading..."),
  maskStyle: {},
  preFetch: 2,
  stayOnFirst: false,
  theme: focusGridTheme
};
FocusGrid.ALIGNMENT = GRID_ALIGNMENT;
export default FocusGrid;

/* eslint-enable react/no-unused-state */